﻿import {hasFlag, translation} from "@2d-front-monorepo/core";
import {
	AttachmentsComponent, DriverId,
	DriverResult,
	EntityHistoryStatusComponent,
	PermitFullEntityResult, RequiredDriverProperties
} from "@2d-front-monorepo/permits-business";
import {PermitTranslations} from "@2d-front-monorepo/shared-translations";
import {JSX} from "react";
import {API_ENDPOINT} from "../../../api-endpoint";

const filesPrefix = API_ENDPOINT.fileDownload;

export function DriverComponent({driver, hiddenEntityProperties, showStatus}: { driver: PermitFullEntityResult<DriverId, DriverResult>, hiddenEntityProperties: RequiredDriverProperties, showStatus: boolean }): JSX.Element {
	return <div className="card card--driver">
		<header className="layout horizontal aligned middle">
			<h5 className="flex">{translation(PermitTranslations.driver)}</h5>
			{showStatus && <EntityHistoryStatusComponent status={driver}/>}
		</header>
		<hr className="no-margin"/>
		<div className="columns gap padded">
			{!hasFlag(hiddenEntityProperties, RequiredDriverProperties.Fullname) &&
				<dl className="title-desc col50">
					<dt>{translation(PermitTranslations.driver__full_name)}</dt>
					<dd>{driver.entity.fullName}</dd>
				</dl>
			}
			{!hasFlag(hiddenEntityProperties, RequiredDriverProperties.LicenseNumber) &&
                <dl className="title-desc col25">
                    <dt>{translation(PermitTranslations.driver__license_number)}</dt>
                    <dd>{driver.entity.licenseNumber}</dd>
                </dl>
			}
			<AttachmentsComponent entity={driver.entity} linkPrefix={filesPrefix} className="col25"/>
		</div>
	</div>
}
